import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import LineTitle from '../atoms/titles/LineTitle';
import LinkButton from '../atoms/button/LinkButton';
import Modal from '../atoms/modal/Modal';
import Calender from '../atoms/form/Calender';
import SelectBox from '../atoms/form/SelectBox';
import CheckBox from '../atoms/form/CheckBox';
import PlanePlanTable from '../molecules/PlanePlanTable';
import {
  setSelectedInboundFlight,
  // fetchOutboundFlights,
  fetchInboundFlights,
  setInboundDepartureAirportId,
  setInboundIncludeConnectingFlight,
  setInboundDate,
  setSelectedInboundDate,
} from '../../modules/flight';
import { useDirections } from '../../utils/search';
import { makeFlightsInput } from '../../utils/input';
import NoResults from '../molecules/NoResults';
import { AIRLINES } from '../../constants';

const flightSelector = (state) => state.flight;

const ModalComingBack = ({
  open,
  onClose,
  onCancel,
  onClick,
  hideSearchForm,
  hideConnectingFlightCheckBox,
  calenderMinDate,
}) => {
  const {
    inboundFlights,
    selectedInboundFlight,
    selectedInboundDate,
    flightsInput,
    searchedFlightsInput,
    searchTime,
  } = useSelector(flightSelector);
  const dispatch = useDispatch();

  const { people, airline, inbound, outbound } = flightsInput;

  const [ initialSelectedFlight, setInitialSelectedFlight ] = useState(undefined);

  useEffect(() => {
    if (!open) {
      setInitialSelectedFlight(undefined);
      return;
    }

    if (initialSelectedFlight) {
      return;
    }

    setInitialSelectedFlight(selectedInboundFlight);
  }, [open, selectedInboundFlight]);

  const handleBack = () => {
    dispatch(setSelectedInboundFlight(initialSelectedFlight));

    onClose();
  };

  const departureDate = outbound.date;

  const handleChangeInboundDate = (dateString) => {
    dispatch(setInboundDate(dateString));

    const newInbound = {
      ...inbound,
      date: dateString,
    };

    const input = makeFlightsInput(people, airline, newInbound, departureDate);
    dispatch(
      fetchInboundFlights(input, 1, 1, true)
    );
  };

  const handleChangeInboundDepartureAirportId = (e) => {
    const newDepartureAirportId = e.target.value;
    dispatch(
      setInboundDepartureAirportId(newDepartureAirportId)
    );

    const newInbound = {
      ...inbound,
      departureAirportId: newDepartureAirportId,
    };

    const input = makeFlightsInput(people, airline, newInbound, departureDate);
    dispatch(
      fetchInboundFlights(input, 1, 1, true)
    );
  };

  const handleChangeInboundIncludeConnectingFlight = () => {
    const newIncludeConnectingFlight = !inbound.includeConnectingFlight;
    dispatch(
      setInboundIncludeConnectingFlight(newIncludeConnectingFlight)
    );
    const newInbound = {
      ...inbound,
      includeConnectingFlight: newIncludeConnectingFlight,
    };

    const input = makeFlightsInput(people, airline, newInbound, departureDate);
    dispatch(
      fetchInboundFlights(input, 1, 1, true)
    );
  };

  const directions = useDirections();

  let arrivalAirportName;
  if (searchedFlightsInput) {
    directions.forEach((d) => {
      const arrivalAirport = d.options.find((airport) => airport.id === searchedFlightsInput.inbound.arrivalAirportId);
      if (arrivalAirport) {
        arrivalAirportName = arrivalAirport.name;
      }
    });
  }

  const showFlights = !!(inboundFlights && inboundFlights.length);

  const inboundSearchTime = searchTime.inbound ? moment(String(searchTime.inbound), "YYYYMMDDHHmm").format("YYYY年MM月DD日HH時mm分") : '';

  return (
    <Modal
      title={'利用便を変更する'}
      open={open}
      onClose={onClose}
      onCancel={onCancel}
      onClick={onClick}
      className="fullHeight"
    >
      <div className="searchModal">
        <div className="searchModalContent">
          <LineTitle text="帰り" />
          {!hideSearchForm && (
            <div className="searchModalForm">
              <div className="searchModalFormItem">
                <div className="searchModalFormTitle">出発日</div>
                <div className="searchModalFormInput">
                  {inbound.date}
                </div>
              </div>
              <div className="searchModalFormItem">
                <div className="searchModalFormTitle">出発地</div>
                <div className="searchModalFormInput">
                  <SelectBox
                    optGroups={directions}
                    value={inbound.departureAirportId}
                    onChange={handleChangeInboundDepartureAirportId}
                  />
                </div>
              </div>
              <div className="searchModalFormItem">
                <div className="searchModalFormTitle">到着地</div>
                <div className="searchModalFormInput">
                  {arrivalAirportName}
                </div>
              </div>
              {!hideConnectingFlightCheckBox && (
                <div className="searchModalFormItem">
                  <CheckBox
                    name="searchFlightModalInbound"
                    id="searchFlightModalInbound"
                    checked={inbound.includeConnectingFlight === true}
                    onChange={handleChangeInboundIncludeConnectingFlight}
                  >
                    乗継便を含める
                  </CheckBox>
                </div>
              )}
            </div>
          )}
        </div>
        {showFlights ? (
          <div className="searchModalContent">
            {inboundSearchTime ? (<div className="searchModalSearchTime">更新日時：{inboundSearchTime}</div>) : ''}
            <div className="searchModalForm">
              <div className="searchModalTable">
                <PlanePlanTable
                  SP
                  tableId="inboundModal"
                  flightOptions={inboundFlights}
                  selectedFlight={selectedInboundFlight}
                  handleSelectFlight={(flight) => {
                    dispatch(setSelectedInboundFlight(flight));
                    dispatch(setSelectedInboundDate(inbound.date));
                  }}
                  isSelectedDateShowing={searchedFlightsInput && searchedFlightsInput.inbound.date === selectedInboundDate}
                />
              </div>
            </div>
          </div>
        ) : (
          <div style={{ margin: '70px 0' }}>
            <NoResults
              title="ご迷惑をおかけしております"
              desc="該当の路線が無いか、アクセスが集中して繋がりにくくなっております。<br/>条件を変えていただくか、しばらくして再検索していただけますようお願い申し上げます。"
            />
          </div>
        )}
        <p style={{ marginTop: 32, fontSize: 10 }}>
          {searchedFlightsInput && searchedFlightsInput.airline === AIRLINES.ana ? (
            <React.Fragment>
              ※プレミアムクラスは選択できません。<br />
              ※ANA便名のうち4700～4840番台の便はエア・ドゥ、2400番台の便はソラシドエア、3800番台の便はスターフライヤー、3100番台の便はＩＢＥＸエアラインズ、4641～4699番台の便はオリエンタルエアブリッジの機材・乗員による運航となります。<br />
              【運航航空会社】<br />
              ANA：全日本空輸、ADO:エア・ドゥ、SNA：ソラシド エア、SFJ：スターフライヤー
            </React.Fragment>
          ) : (
            <React.Fragment>
              【乗継便選択時のクラスＪ席ご注意】<br />
              ・経由便の場合、全区間でクラスＪ席を予約できない場合があります。<br />
              ・クラスＪ設定機材で空席がある区間のみ、クラスＪ席でのご予約となります。<br />
              ・クラスＪ利用時の差額は、ご予約可能な区間分のみ適用し表示しております。<br /><br />
              【運航航空会社】<br />
              JAL/JL：日本航空、JTA：日本トランスオーシャン航空、RAC：琉球エアコミューター、JAC：日本エアコミューター、J-AIR：ジェイ・エア、FDA：フジドリームエアラインズ、HAC：北海道エアシステム、AMX：天草エアライン
            </React.Fragment>
          )}
        </p>
        <div className="action">
          {showFlights && (
            <div className="research"><LinkButton onClick={onClose}>変更する</LinkButton></div>
          )}
          <div className="close"><LinkButton buttonType="navigateMin" onClick={handleBack}>閉じる</LinkButton></div>
        </div>
      </div>
    </Modal>
  );
};


ModalComingBack.defaultProps = {
};

ModalComingBack.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  hideSearchForm: PropTypes.bool,
  hideConnectingFlightCheckBox: PropTypes.bool,
  calenderMinDate: PropTypes.string,
};

export default ModalComingBack;
